import React from 'react';
import { Box, Typography } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import {
  BorrowerType,
  type TFinancialConditionFormValues,
} from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/types.ts';
import { documentGenerationFormStyles } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/styles.ts';

export const SoleTraderFinancialStatementSection: React.FC = () => {
  const { watch } = useFormContext<TFinancialConditionFormValues>();
  const borrowerType = watch('borrowerType')?.value;
  const isSoleTrader = borrowerType === BorrowerType.SoleTrader;

  if (!isSoleTrader) {
    return null;
  }

  return (
    <Box sx={documentGenerationFormStyles.section}>
      <Typography component="h3" sx={documentGenerationFormStyles.sectionTitle}>
        9. Фінансова звітність
      </Typography>
      <Typography color="text.secondary">
        Фінансова звітність за останній звітний квартал або річна фінансова звітність, надана Банку,
        відповідає вимогам Закону України «Про бухгалтерський облік та фінансову звітність в
        Україні».
      </Typography>
    </Box>
  );
};
